import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { IconByKey } from './IconByKey';
import { includedItems } from '../data/content';
export function Included() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="included-title" data-id="element-185" data-mp="4fdb9kvedd1w">
      <div className="mx-auto max-w-4xl" data-id="element-186" data-mp="3vlxvolqy5mpy">
        <div id="included-title" data-id="element-187" data-mp="3vj1y4yj0h021">
          <SectionHeading title="You’ll also receive" data-id="element-188" data-mp="x3smrxfbld8h" />
        </div>

        <ul className="mt-10 divide-y divide-brand-100" data-id="element-189" data-mp="x0wou93h2ok1">
          {includedItems.map(item => <li key={item.title} className="flex gap-4 py-5 sm:gap-6" data-id="element-190" data-mp="s2bkbxh6tips">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-800 text-gold-light" data-id="element-191" data-mp="n38i0ksldqli">
                <IconByKey icon={item.icon} className="h-6 w-6" data-id="element-192" data-mp="37vamlx5aor1t" />
              </span>
              <div data-id="element-193" data-mp="37t7mulecbjjw">
                <h3 className="font-serif text-xl font-bold text-ink" data-id="element-194" data-mp="32w7jii8vkuwh">{item.title}</h3>
                <p className="mt-1 text-[16px] leading-relaxed text-muted" data-id="element-195" data-mp="32yk6j9thpvge">{item.body}</p>
              </div>
            </li>)}
        </ul>

        <p className="mt-6 text-center font-serif text-xl font-semibold italic text-brand-700 sm:text-2xl" data-id="element-196" data-mp="3aplbz384figp">
          Any day you want to practice, you’ll have a clear place to begin.
        </p>

        <SectionCta label="I want access to the complete system" data-id="element-197" data-mp="30rfgp4gtlakt" />
      </div>
    </section>;
}